//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'WalkingTestDistance6',
  data() {
    return {
      defaultJson:{
        "Height": "身高",
        "Age": "年龄",
        "Weight": "体重",
      },
      form:{
        gender:null,
        h:'',
        age:'',
        w:'',
      },
      hasScore:false,
      disabled:false,
      dataList1: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
      res:'...',
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form,'self.form');
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0
        if(form.gender == 1) { // 男
          result = 757 * form.h / 100 - 5.02 * form.age - 1.76 * form.w - 309
        } else { //女
          result = 211 * form.h / 100 - 5.78 * form.age - 2.29 * form.w + 667
        }

        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WalkingTestDistance6.vue